
















































import Matrix from "@/components/Matrix/index.vue";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { defaultParams } from '@/modules/layers/PrettyPictureLayer/defaultParams';

@Component({
  components: { Matrix },
})
export default class extends Vue {
  @Prop({ required: true })
  isOpen!: boolean

  @Prop({ required: true })
  title!: string

  @Prop({ required: true })
  filters!: string[]

  @Prop({ required: true })
  params!: ReturnType<typeof defaultParams>["m31"]

  @Prop({ required: true })
  reset!: () => void

  @Prop({ required: true })
  goThere!: () => void
}
